import { CLIMBING_STYLES } from '../constants.js';
import { isFirstTimeAscent } from '../ascentTypes.js';

export const calculateSuccessRates = (data, climbingStyle) => {
  const routeAttempts = {};
  const dataErrors = [];
  
  data?.forEach(ascent => {
    const routeId = ascent["Route ID"];
    if (!routeId) return;
    
    const grade = climbingStyle === CLIMBING_STYLES.BOULDER ? ascent.vgrade : ascent.ewbanks;
    
    if (!routeAttempts[routeId]) {
      routeAttempts[routeId] = {
        attempts: [],
        onsightCount: 0,
        flashCount: 0,
        firstAttemptType: null,
        grade: grade,
        name: ascent["Route Name"],
        ascentDates: [] // Track dates for error reporting
      };
    }
    
    routeAttempts[routeId].attempts.push(ascent["Ascent Type"]);
    routeAttempts[routeId].ascentDates.push(ascent["Ascent Date"]);
    
    if (routeAttempts[routeId].attempts.length === 1) {
      routeAttempts[routeId].firstAttemptType = ascent["Ascent Type"];
    }
    
    if (ascent["Ascent Type"] === "Onsight") {
      routeAttempts[routeId].onsightCount++;
      if (routeAttempts[routeId].onsightCount > 1) {
        dataErrors.push({
          type: 'Multiple Onsights',
          routeName: ascent["Route Name"],
          routeId: routeId,
          grade: ascent["Route Grade"],
          dates: routeAttempts[routeId].ascentDates
            .filter((_, i) => routeAttempts[routeId].attempts[i] === "Onsight")
            .map(d => new Date(d).toLocaleDateString())
        });
      }
    }
    
    if (ascent["Ascent Type"] === "Flash") {
      routeAttempts[routeId].flashCount++;
      if (routeAttempts[routeId].flashCount > 1) {
        dataErrors.push({
          type: 'Multiple Flashes',
          routeName: ascent["Route Name"],
          routeId: routeId,
          grade: ascent["Route Grade"],
          dates: routeAttempts[routeId].ascentDates
            .filter((_, i) => routeAttempts[routeId].attempts[i] === "Flash")
            .map(d => new Date(d).toLocaleDateString())
        });
      }
    }

    // Check for impossible combinations
    if (routeAttempts[routeId].onsightCount > 0 && routeAttempts[routeId].flashCount > 0) {
      dataErrors.push({
        type: 'Both Onsight and Flash',
        routeName: ascent["Route Name"],
        routeId: routeId,
        grade: ascent["Route Grade"],
        dates: routeAttempts[routeId].ascentDates
      });
    }
  });

  // Move errorsByType definition outside the if block
  const errorsByType = dataErrors.reduce((acc, error) => {
    if (!acc[error.type]) acc[error.type] = [];
    acc[error.type].push(error);
    return acc;
  }, {});

  // Now you can still log errors if needed
  if (dataErrors.length > 0) {
    console.error('Data validation errors found:', dataErrors);
    console.table(errorsByType);
  }

  const totalDistinctRoutes = Object.keys(routeAttempts).length;
  const onsightCount = Object.values(routeAttempts)
    .filter(r => r.onsightCount === 1).length;
  const flashCount = Object.values(routeAttempts)
    .filter(r => r.flashCount === 1).length;
  
  // Calculate rates only counting valid ascents
  const firstTrySuccessCount = onsightCount + flashCount;
  const onsightRate = ((onsightCount / totalDistinctRoutes) * 100).toFixed(1);
  const flashRate = ((flashCount / totalDistinctRoutes) * 100).toFixed(1);
  const firstTryRate = ((firstTrySuccessCount / totalDistinctRoutes) * 100).toFixed(1);

  return {
    totalRoutes: totalDistinctRoutes,
    onsightCount,
    flashCount,
    firstTrySuccessCount,
    onsightRate,
    flashRate,
    firstTryRate,
    dataErrors: dataErrors.length > 0 ? errorsByType : null
  };
};